const ExpandLine = ({ className = '', ...props }) => {
    return (
        <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M2 0.562377L2 18.5624L-7.86805e-07 18.5624L0 0.562377L2 0.562377ZM7.828 10.5624L13.9 16.6334L12.486 18.0474L4 9.56238L12.485 1.07738L13.9 2.49138L7.83 8.56238L19 8.56238L19 10.5624L7.828 10.5624Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ExpandLine;
